var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocSimIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 3.15002C13.4999 3.15002 10.4129 6.88052 5.83643 6.88052C5.83643 21.024 13.4999 23.8455 13.4999 23.8455C13.4999 23.8455 21.1634 21.024 21.1634 6.88052C16.5914 6.88052 13.4999 3.15002 13.4999 3.15002Z",
    stroke: "#151C2B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0873 9.22502C23.4903 9.09002 25.1013 9.40502 25.3218 10.188C25.7448 11.7045 20.7993 14.418 14.2698 16.2495C7.74032 18.0765 2.10182 18.333 1.67882 16.812C1.40882 15.849 3.30332 14.4045 6.39932 13.0095",
    stroke: "#151C2B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91305 9.22502C3.51005 9.09002 1.89905 9.40502 1.67855 10.188C1.25555 11.7045 6.20105 14.418 12.7306 16.2495C19.2601 18.0765 24.8986 18.333 25.3216 16.812C25.5916 15.849 23.6971 14.4045 20.6011 13.0095",
    stroke: "#151C2B",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocSimIcon);
export default __webpack_public_path__ + "static/media/soc-sim-icon.5a792910e0606dc65da8eba8643f2862.svg";
export { ForwardRef as ReactComponent };